import { usePaymentHistory } from '~/lib/Queries';
import { ObjectTypes } from '~/lib/ObjectTypes';
import PaymentHistory from '~/components/payments/PaymentHistory';
import ErrorMessageBlock from '~/components/ErrorMessageBlock';
import { formatCurrency } from '~/lib/CurrencyHelpers.js';

const PaymentList = ({
    type,
    id,
    requiresSavedPaymentMethod,
    renderDetails,
}) => {
    const {
        data,
        isLoading,
        refetch: refetchPaymentHistory,
    } = usePaymentHistory(type, id);
    const history = data?.payments || [];

    return (
        <>
            {requiresSavedPaymentMethod &&
                !isLoading &&
                !data?.clientSavedPaymentMethods?.length && (
                    <ErrorMessageBlock className="mb-2">
                        Client has no saved payment methods to charge for
                        renewal
                    </ErrorMessageBlock>
                )}
            <PaymentHistory
                history={history}
                codes={data?.codes || []}
                savedPaymentMethods={data?.savedPaymentMethods}
                renderDetails={renderDetails}
                refetch={refetchPaymentHistory}
                onUpdate={() => {
                    if (typeof refetch === 'function') {
                        refetch();
                    }
                    refetchPaymentHistory();
                }}
            />
        </>
    );
};

export default PaymentList;
